export default "__VITE_ASSET__D1i3ieCX__"